module.exports = __webpack_public_path__ + "static/media/EA77.6bcecee0.png";